module.exports = __webpack_public_path__ + "img/klarna-2.6ee4608.svg";